import { render } from "./PrivilegesPage.vue?vue&type=template&id=71b844c6&scoped=true"
import script from "./PrivilegesPage.vue?vue&type=script&lang=js"
export * from "./PrivilegesPage.vue?vue&type=script&lang=js"

import "./PrivilegesPage.vue?vue&type=style&index=0&id=71b844c6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b844c6"]])

export default __exports__